import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { InputList } from "./InputList";
import s from "../../ProductConfiguratorComponent.module.scss";

export const TechnicalDesignResults = Scrivito.connect(
  ({ productConfiguration }) => {
    const { outputs = [] } = productConfiguration || {};

    return (
      <div className="px-4">
        <InputList
          list={outputs}
          isValueEditable={false}
          headerStyles="font-md pb-2 mb-0"
          propertyStyles={cx(
            "pb-2 d-flex justify-content-between align-items-center font-md",
            s.cardInputRow,
          )}
        />
      </div>
    );
  },
);
